module.exports = __webpack_public_path__ + "media/images/area/feature/common/icon_arrow_slide2-25c0c229354a1d8fe538cb70dade6478.svg";